import { Base } from "../../../../base/components/base"
import { tabStyle } from "./tab.style"

export const Tab = (id: string) => {

    const base = Base()
    base.style(tabStyle)

    function show() {
        base.style({ display: 'flex' })
    }

    function hide() {
        base.style({ display: 'none' })
    }

    return Object.assign(base, {
        id,
        show,
        hide
    })
}